module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('MCP_Login_Wizard', {

		configure: function(options) {
			this.registerOptions('', {
				'widgets.login.widget': 'MCP_Login_Wizard_LoginForm',
				'widgets.forgotPassword.widget': 'MCP_Login_Wizard_ForgotForm',
				'widgets.phoneNumberAuth.widget': 'MCP_Verification_Form',
				// 'widgets.phoneNumberAuth': {
				// 	template: 'verification_form',
				// 	//test
				// 	templateOptions: {phone: {number: 'xxxxxxx11'}}
				// },
			});

			this.callParent('configure', arguments);
		},

	}, 'Login_Wizard');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/login/wizard.js
// module id = 199
// module chunks = 5